/**
 * Project : workspace
 * File    : AsyncImageView.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package component.image

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import com.github.panpf.sketch.AsyncImage
import com.github.panpf.sketch.rememberAsyncImageState
import com.github.panpf.sketch.request.ComposableImageOptions

@Composable
/**
 * Executes the async image view operation.
 *
 * @receiver TODO
 * @param url The url.
 * @param onFail The on fail.
 * @return Unit – no return value.
 */
fun AsyncImageView(url: String, onFail: (() -> Unit) = {}) {
    Box (modifier = Modifier.fillMaxSize()){
        AsyncImage(
            uri = url,
            state = rememberAsyncImageState(ComposableImageOptions {
//                placeholder(Res.drawable.placeholder)
//                error(Res.drawable.error)
                crossfade()
                // There is a lot more...
            }),
            contentDescription = "photo",
            contentScale = ContentScale.FillBounds,
            modifier = Modifier.fillMaxSize()
        )
    }
}